import { Component } from '@angular/core'

@Component({
  selector: 'se-po-video-streaming',
  templateUrl: './video-streaming.component.html',
  styleUrls: ['./video-streaming.component.scss'],
  standalone: false,
})
export class VideoStreamingComponent {}
